import { Matrix3 } from './Matrix3';
import { GlyphCache } from './GlyphCache';

export class GlyphLineCache {
  transform: Matrix3 | null = null; // can be null
  glyphs: GlyphCache[];

  constructor(transform: Matrix3 | null, glyphs: GlyphCache[]) {
    this.transform = transform;
    this.glyphs = glyphs;
  }
}
